<div class="cntI mNavegacion" *ngIf="this.isIndex">
	<div class="mNv flx text-center">
		<div class="col-12 alerta-registrado text-center" *ngIf="this.noworkingIE">
            <p>Su navegador <strong>no es compatible</strong> con esta aplicación por favor utilice Google Chrome, Microsoft Edge u otro navegador más reciente.</p>
        </div>
		<div class="dMedio"></div>
		<div class="dUno dmCinco text-left" id="lFB">
			<a routerLink="/"><img src="./assets/images/logo-new.png" alt="logo Fundación BEST a.c."></a>
		</div>
		<div class="dDoce dmSeis text-right" id="lBg">
			<img src="./assets/images/burger-logo.png" alt="burger Logo" id="btnBurguer" [ngClass]="{'FmenuNoActivo': activo=='btnMovil','FmenuActivo':activo=='btnMovilOpen'}" (click)="activo='btnMovil'"/>
			<img src="./assets/images/burger-logo-close.png" alt="burger Logo" id="bnBgCe" [ngClass]="{'FmenuActivo': activo=='btnMovil','FmenuNoActivo':activo=='btnMovilOpen'}" (click)="activo='btnMovilOpen'"/>
		</div>
		<div class="dDiezM dmDoce mNvI flx" id="mNv" [ngClass]="{'FmenuNoActivo':activo=='seleccionado' || activo=='btnMovilOpen','FmenuActivo':activo=='btnMovil'}">
			<div class="dUnoM dmDoce tbNvIt"  (click)="activo='seleccionado'">
				<a routerLink="quienes-somos">QUIÉNES SOMOS</a>
			</div>
			<div class="dUnoM dmDoce tbNvIt"  (click)="activo='seleccionado'">
				<a routerLink="servicios">SERVICIOS</a></div>
			<div class="dUnoM dmDoce tbNvIt"  (click)="activo='seleccionado'">
				<a routerLink="estadisticas">ESTADÍSTICAS</a>
			</div>
			<div class="dUnoM dmDoce tbNvIt"  (click)="activo='seleccionado'">
				<a routerLink="salud">SALUD INTEGRAL</a>
			</div>
			<div class="dUnoM dmDoce tbNvIt"  (click)="activo='seleccionado'">
				<a>UBICACIONES</a>
				<ul class="sbmNv">
					<a routerLink="consultorios"><li class="text-left">CONSULTORIOS MÉDICOS</li></a>
					<a routerLink="consultorios-dentales"><li class="text-left">CONSULTORIOS DENTALES</li></a>
					<a routerLink="consultorios-nutricionales"><li class="text-left">CONSULTORIOS NUTRICIONALES</li></a>
					<a routerLink="consultorios-psicologicos"><li class="text-left">CONSULTORIOS PSICOLÓGICOS</li></a>
					<a routerLink="consultorios-especialidades"><li class="text-left">CONSULTORIOS ESPECIALIDADES</li></a>
				</ul>
			</div>
			<div class="dUno dmDoce tbNvIt"  (click)="activo='seleccionado'">
				<a (click)="getAll()">NOTAS</a>
			</div>
			<div class="dUnoM dmDoce tbNvIt"  (click)="activo='seleccionado'">
				<a routerLink="simposios">EVENTOS</a>
			</div>
			<div class="dUno dmDoce tbNvIt"  (click)="activo='seleccionado'">
				<a routerLink="empleo">ÚNETE</a>
			</div>
			<div class="dUno dmDoce tbNvIt"  (click)="activo='seleccionado'">
				<a routerLink="contacto">CONTACTO</a>
			</div>
		</div>
	</div>
</div>
